import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

const RadarChartYou = ({ data, selectedOption2 }) => {
  const options = {
    series: [
      {
        name: "Series 1",
        data: [20, 100, 40, 30, 50, 80, 33],
      },
    ],
    chart: {
      height: 550,
      type: "radar",
      toolbar: {
        show: false, // This will hide the toolbar, including the download option
      },
    },
    dataLabels: {
      enabled: true,
    },
    plotOptions: {
      radar: {
        size: 200,
        polygons: {
          strokeColors: "#e9e9e9",
          fill: {
            colors: ["#f8f8f8", "#fff"],
          },
        },
      },
    },
    colors: ["#6DD47D", "#53860F"],
    markers: {
      size: 4,
      colors: ["#fff"],
      strokeColor: "#6DD47D",
      strokeWidth: 2,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val;
        },
      },
    },
    xaxis: {
      categories: ["USA", "India", "UK", "You", "NL", "Germany", "Russia"],
      labels: {
        style: {
          colors: "#ffffff",
          fontSize: "18px",
        },
      },
    },
    yaxis: {
      labels: {
        formatter: function (val, i) {
          if (i % 2 === 0) {
            return val;
          } else {
            return "";
          }
        },
      },
    },
  };

  const [chartOptions, setChartOptions] = useState(null);

  useEffect(() => {
    if (data && Array.isArray(data) && data?.length > 0) {
      const validData = data.filter(
        (item) =>
          item &&
          typeof item === "object" &&
          "country" in item &&
          selectedOption2 in item &&
          item[selectedOption2] !== undefined &&
          item[selectedOption2] !== null
      );

      if (validData?.length === 0) {
        console.error("No valid data points found");
        setChartOptions(null);
        return;
      }

      const baseOptions = {
        chart: {
          height: 500,
          type: "radar",
          toolbar: { show: false },
        },
        dataLabels: { enabled: true },
        plotOptions: {
          radar: {
            size: 200,
            polygons: {
              strokeColors: "#e9e9e9",
              fill: { colors: ["#f8f8f8", "#fff"] },
            },
          },
        },
        colors: ["#6DD47D"],
        markers: {
          size: 4,
          colors: ["#fff"],
          strokeColor: "#6DD47D",
          strokeWidth: 2,
        },
        tooltip: {
          y: { formatter: (val) => val.toFixed(2) },
        },
        xaxis: {
          categories: validData?.map((item) => item.isYou ? "You" : item.country),
          labels: {
            style: { colors: "#000000", fontSize: "18px" },
          },
        },
        yaxis: { show: false },
        grid: { show: false },
      };

      const seriesData = validData?.map((item) => ({
        x: item.country,
        y: parseFloat(item[selectedOption2]) || 0,
      }));

      setChartOptions({
        ...baseOptions,
        series: [{ name: selectedOption2, data: seriesData }],
      });
    } else {
      console.error("Invalid or empty data received");
      setChartOptions(null);
    }
  }, [data, selectedOption2]);

  return (
    <div id="chart">
      {chartOptions && (
        <ReactApexChart
          options={chartOptions}
          series={chartOptions.series}
          type="radar"
          height={500}
        />
      )}
    </div>
  );
};

export default RadarChartYou;
